"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultRequestHeaderType = void 0;
/**
 * Defines the names of frequently used request headers.
 */
var DefaultRequestHeaderType;
(function (DefaultRequestHeaderType) {
    // standard headers
    DefaultRequestHeaderType["ACCEPT_LANGUAGE"] = "Accept-Language";
    DefaultRequestHeaderType["AUTHORIZATION"] = "Authorization";
    // custom headers
    DefaultRequestHeaderType["APPLICATION_TOKEN"] = "X-Application-Token";
    DefaultRequestHeaderType["PREVIEW_SANDBOX"] = "X-Preview-Sandbox";
    DefaultRequestHeaderType["PREVIEW_TOKEN"] = "X-Preview-Token";
    DefaultRequestHeaderType["PREVIEW_DATE"] = "X-Preview-Date";
})(DefaultRequestHeaderType = exports.DefaultRequestHeaderType || (exports.DefaultRequestHeaderType = {}));
//# sourceMappingURL=client.js.map